import React, { useState, useEffect, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";
import { url } from "../../Constant/TextConstant";
import "./ServiceProviderDetails.css";
import Header from "../Header";
import { decryptData } from "../../utils/encryption";
import { apiAxios as axios } from "../../utils/apiClient.js";
import Compressor from "compressorjs";
import Footer from "../Footer/Footer";
import { fetchUniqueIds, sendFCMNotification } from "../../Services/NotificationServices";
import { Helmet } from "react-helmet";
import { useUserLocation } from "../../utils/useUserLocation";
const ServiceProviderDetails = () => {
  const { encryptedProviderMobile } = useParams();
  const providerMobile = decryptData(encryptedProviderMobile);
  const location = useLocation();
  const { serviceProviderName } = location.state || {};
  const [imageFiles, setImageFiles] = useState([null, null]);
  const [serviceDetails, setServiceDetails] = useState({
    storeName: "",
    businessName: "",
    experience: "",
    address: "",
    latitude: "",
    longitude: "",
    facebook: "",
    instagram: "",
    youtube: "",
    imageUrl: "",
    storeTitle: "",
  });
  
  const [selectedService, setSelectedService] = useState(null);
  const [bookingDialogOpen, setBookingDialogOpen] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [description, setDescription] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [serviceRating, setServiceRating] = useState(0);
  const [usersServices, setUsersServices] = useState([]);
  const [fullReview, setFullReview] = useState([]);
  const [isFavourite, setIsFavourite] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRating, setSelectedRating] = useState(null);
  const [reviewText, setReviewText] = useState("");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showAllReviews, setShowAllReviews] = useState(false);

  const { currentUser, currentUserName } = useAuth();
  const baseAPIUrl = url.baseAPIUrl;
  // Replace the existing location state with the useUserLocation hook
  const {
    location: currentLocation,
    error: locationError,
    isLoading: isLocationLoading,
    updateLocation,
  } = useUserLocation();

  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(() => {
    return localStorage.getItem("selectedCategory") || "products";
  });

   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  // Update localStorage whenever selectedCategory changes
  useEffect(() => {
    localStorage.setItem("selectedCategory", selectedCategory);
  }, [selectedCategory]);

  // Handler for modal close with location update
  const handleModalClose = (shouldClose, newCoordinates = null) => {
    setShowModal(false);
    if (newCoordinates) {
      // Update location through the hook's update function
      updateLocation({
        coordinates: {
          latitude: newCoordinates.latitude,
          longitude: newCoordinates.longitude,
        },
        address: newCoordinates.address || "",
        details: newCoordinates.details || null,
      });
    }
  };

  const showSnackbar = useCallback((message, severity) => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          fetchServiceDetails(),
          fetchServiceRatings(),
          fetchUsersServices(),
          fetchReviews(),
        ]);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [providerMobile]);

  const fetchServiceDetails = async () => {
    try {
      const response = await axios.get(
        `${baseAPIUrl}/api/serviceprovider/binddetails`,
        { params: { ProviderMobile: providerMobile } }
      );
      const data = response.data;

      setServiceDetails({
        storeName: (data.FullName || "Default Store Name").toUpperCase(),
        businessName: (data.BusinessName || "Default Business Name").toUpperCase(),
        experience: data.Experience || "Fresher",
        address: data.Address || "No Address",
        latitude: data.Latitude || "",
        longitude: data.Longitude || "",
        facebook: data.Facebook || "",
        instagram: data.Instagram || "",
        youtube: data.Youtube || "",
        imageUrl: data.ProfileImage
          ? `${url.serviceImageStartingPath}${data.ProfileImage}`
          : "",
        storeTitle: (data.ServiceType || "Default Store Title").toUpperCase(),
      });
    } catch (err) {
      throw new Error("Failed to load service details");
    }
  };

  const fetchServiceRatings = async () => {
    try {
      const response = await axios.get(
        `${baseAPIUrl}/api/ServiceLikeReviewCall/GetServiceRatingPercentage`,
        { params: { ProviderMobile: providerMobile } }
      );
      const rating = response.data;
      setServiceRating(rating / 20);
    } catch (err) {
      setServiceRating(0);
    }
  };

  const fetchUsersServices = async () => {
    try {
      const response = await axios.get(
        `${baseAPIUrl}/api/BindServiceProduct/GetServicesByMobile`,
        { params: { providerMobile } }
      );
      setUsersServices(response.data);
    } catch (err) {
      setUsersServices([]);
    }
  };

  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        `${baseAPIUrl}/api/ServiceLikeReviewCall/GetReview`,
        { params: { ProviderMobile: providerMobile } }
      );
      setFullReview(response.data || []);
    } catch (err) {
      setFullReview([]);
    }
  };

 

  const openBookingDialog = (service) => {
    setSelectedService(service);
    setSelectedServices([]);
    setDescription("");
    setBookingDialogOpen(true);
  };

  const handleServiceSelection = (serviceName, isSelected) => {
    setSelectedServices((prev) =>
      isSelected
        ? [...prev, serviceName]
        : prev.filter((name) => name !== serviceName)
    );
  };

  const calculateTotalMRP = () => {
    if (!selectedService) return 0;
    return selectedServices.reduce((total, serviceName) => {
      const service = usersServices.find(
        (s) => s.ServiceName === serviceName
      );
      return total + (parseFloat(service?.Mrp) || 0);
    }, 0);
  };

  const bookService = async () => {
    if (!selectedService || selectedServices.length === 0) {
      showSnackbar("Please select at least one service", "warning");
      return;
    }

    try {
      const bookingData = {
        customerMobile: currentUser,
        customerName: currentUserName,
        providerMobile: providerMobile,
        serviceNames: selectedServices.join(","),
        description: description || "No description",
      };

      await axios.post(`${baseAPIUrl}/api/ServiceBooking/BookService`, null, {
        params: {
          CustomerName: bookingData.customerName,
          CustomerMobile: bookingData.customerMobile,
          ProviderMobile: bookingData.providerMobile,
          ServiceNames: bookingData.serviceNames,
          Description: bookingData.description,
        },
      });

      setBookingDialogOpen(false);
      const uniqueIds = await fetchUniqueIds(providerMobile);
      await sendFCMNotification({
        Tokens: uniqueIds,
        Title: "New Service Booking",
        Body: `A new service booking has been placed by ${
          currentUserName || "Customer"
        }`,
        ScreenRoute: "/serviceBooking",
      });

      // Send notification to Support
      const supportUniqueIds = await fetchUniqueIds("9523812734");
      if (supportUniqueIds) {
        await sendFCMNotification({
          Tokens: supportUniqueIds,
          Title: "New Service Booking",
          Body: `A new service booking has been placed by ${
            currentUserName || "Customer"
          }`,
          ScreenRoute: "/supportServiceBooking",
        });
      }
      showSnackbar(
        "Service booked successfully! The provider will contact you soon.",
        "success"
      );
    } catch (error) {
      showSnackbar("Failed to book service", "error");
    }
  };

  const pickImage = (idx, file) => {
    if (!file) return;
    
    new Compressor(file, {
      quality: 0.6,
      maxWidth: 800,
      success(result) {
        const newFiles = [...imageFiles];
        newFiles[idx] = result;
        setImageFiles(newFiles);
      },
      error(err) {
        showSnackbar("Failed to process image", "error");
      },
    });
  };

  const removeImage = (idx) => {
    const newFiles = [...imageFiles];
    newFiles[idx] = null;
    setImageFiles(newFiles);
  };

  const uploadImage = async (file) => {
    if (!file) return "";
    const form = new FormData();
    form.append("file", file, file.name);
    try {
      const resp = await axios.post(
        `${baseAPIUrl}/api/UploadImage/UploadReviewImage`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return resp.data.trim().replace(/"/g, "");
    } catch (err) {
      showSnackbar("Failed to upload image", "error");
      return "";
    }
  };

  const submitReview = async () => {
    if (!selectedRating) {
      showSnackbar("Please select a rating", "warning");
      return;
    }
    if (!reviewText.trim()) {
      showSnackbar("Please write a review", "warning");
      return;
    }

    try {
      const uploaded = await Promise.all(
        imageFiles.map((f) => (f ? uploadImage(f) : Promise.resolve("")))
      );

      await axios.post(
        `${baseAPIUrl}/api/ServiceLikeReviewCall/SubmitReview`,
        null,
        {
          params: {
            rating: selectedRating,
            review: reviewText,
            providermobile: providerMobile,
            customermobile: currentUser,
            name: currentUserName || "Guest",
            image1: uploaded[0] || "",
            image2: uploaded[1] || "",
          },
        }
      );

      setImageFiles([null, null]);
      setSelectedRating(null);
      setReviewText("");
      showSnackbar("Review submitted successfully", "success");
      fetchReviews();
      fetchServiceRatings();
    } catch (err) {
      showSnackbar("Failed to submit review", "error");
    }
  };

  const calculateRatingCounts = (reviews) => {
    const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    reviews.forEach((review) => counts[review.Rating]++);
    return counts;
  };

  const ratingCounts = calculateRatingCounts(fullReview);

  if (loading) {
    return (
      <div className="service-provider-screen-loading">
        <div className="loading-spinner"></div>
        Loading service details...
      </div>
    );
  }

  if (error) {
    return (
      <div className="service-provider-screen-error">
        Error: {error}
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          {serviceDetails.businessName
            ? `${serviceDetails.businessName} | ${serviceDetails.storeTitle} Services`
            : "Service Provider Details"}
        </title>
        <meta
          name="description"
          content={
            serviceDetails.businessName
              ? `Book ${serviceDetails.storeTitle} services with ${
                  serviceDetails.businessName
                }. ${serviceRating.toFixed(1)}★ rating from ${
                  fullReview.length
                } reviews. ${serviceDetails.address || ""}`
              : "View details about this service provider including services offered, ratings, and reviews."
          }
        />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={
            serviceDetails.businessName
              ? `${serviceDetails.businessName} | Service Provider`
              : "Service Provider Details"
          }
        />
        <meta
          property="og:description"
          content={
            serviceDetails.businessName
              ? `Professional ${serviceDetails.storeTitle} services by ${
                  serviceDetails.businessName
                }. Rated ${serviceRating.toFixed(1)} stars.`
              : "View professional service provider details"
          }
        />
        <meta
          property="og:image"
          content={
            serviceDetails.imageUrl || "/images/default-service-provider.jpg"
          }
        />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={
            serviceDetails.businessName
              ? `${serviceDetails.businessName} | Service Provider`
              : "Service Provider Details"
          }
        />
        <meta
          name="twitter:description"
          content={
            serviceDetails.businessName
              ? `Professional services by ${
                  serviceDetails.businessName
                }. Rated ${serviceRating.toFixed(1)}/5.`
              : "View professional service provider details"
          }
        />
        <meta
          name="twitter:image"
          content={
            serviceDetails.imageUrl || "/images/default-service-provider.jpg"
          }
        />
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            name: serviceDetails.businessName,
            description: `Professional ${serviceDetails.storeTitle} services`,
            image: serviceDetails.imageUrl,
            telephone: providerMobile,
            address: {
              "@type": "PostalAddress",
              streetAddress: serviceDetails.address,
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: serviceDetails.latitude,
              longitude: serviceDetails.longitude,
            },
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: serviceRating,
              ratingCount: fullReview.length,
            },
          })}
        </script>
      </Helmet>

      <Header
        userLocation={currentLocation} // Use currentLocation from hook
        setShowModal={setShowModal}
        setUserLocation={updateLocation} // Use updateLocation from hook
        showModal={showModal}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />

      <div className="service-provider-screen-container">
        {/* Hero Section */}
        <div className="service-provider-screen-hero">
          <div className="service-provider-screen-hero-content">
            {serviceDetails.imageUrl && (
              <div className="service-provider-screen-profile-image">
                <img
                  src={serviceDetails.imageUrl}
                  alt={serviceDetails.storeName}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/default-profile.png";
                  }}
                />
              </div>
            )}
            <div className="service-provider-screen-title-section">
              <h1 className="service-provider-screen-business-name">
                {serviceDetails.businessName}
              </h1>
              <p className="service-provider-screen-store-title">
                {serviceDetails.storeTitle}
              </p>

              <div className="service-provider-screen-rating-section">
                <div className="service-provider-screen-rating-badge">
                  <span className="service-provider-screen-rating-star">
                    ⭐
                  </span>
                  <span className="service-provider-screen-rating-value">
                    {serviceRating.toFixed(1)}
                  </span>
                  <span className="service-provider-screen-review-count">
                    ({fullReview.length} reviews)
                  </span>
                </div>
                <span className="service-provider-screen-experience">
                  {serviceDetails.experience} years experience
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Action Buttons */}
        <div className="service-provider-screen-quick-actions">
          <button
            className="service-provider-screen-action-button call"
            onClick={() => window.open(`tel:${providerMobile}`)}
          >
            <span className="service-provider-screen-action-icon">📞</span>
            <span>Call</span>
          </button>
          <button
            className="service-provider-screen-action-button whatsapp"
            onClick={() => window.open(`https://wa.me/${providerMobile}`)}
          >
            <span className="service-provider-screen-action-icon">💬</span>
            <span>WhatsApp</span>
          </button>
          {serviceDetails.latitude && serviceDetails.longitude && (
            <button
              className="service-provider-screen-action-button direction"
              onClick={() =>
                window.open(
                  `https://www.google.com/maps/dir/?api=1&destination=${serviceDetails.latitude},${serviceDetails.longitude}`
                )
              }
            >
              <span className="service-provider-screen-action-icon">📍</span>
              <span>Direction</span>
            </button>
          )}
          {usersServices.length > 0 && (
            <button
              className="service-provider-screen-action-button book"
              onClick={() => openBookingDialog(usersServices[0])}
            >
              <span className="service-provider-screen-action-icon">📅</span>
              <span>Book Now</span>
            </button>
          )}
        </div>

        {/* About Section */}
        <div className="service-provider-screen-section">
          <h2 className="service-provider-screen-section-title">About</h2>
          <div className="service-provider-screen-about-content">
            <p className="service-provider-screen-owner">
              <strong>Owner:</strong> {serviceDetails.storeName}
            </p>
            {serviceDetails.address && (
              <p className="service-provider-screen-address">
                <strong>Address:</strong> {serviceDetails.address}
                <button
                  className="service-provider-screen-copy-address"
                  onClick={() => {
                    navigator.clipboard.writeText(serviceDetails.address);
                    showSnackbar("Address copied to clipboard", "success");
                  }}
                >
                  Copy
                </button>
              </p>
            )}
          </div>
        </div>

        {/* Services Section */}
        <div className="service-provider-screen-section">
          <h2 className="service-provider-screen-section-title">Services</h2>
          {usersServices.length > 0 ? (
            <div className="service-provider-screen-services-grid">
              {usersServices.map((service, index) => (
                <ServiceCard
                  key={index}
                  service={service}
                  currentImageIndex={currentImageIndex}
                  onImageChange={setCurrentImageIndex}
                  onBookNow={() => openBookingDialog(service)}
                />
              ))}
            </div>
          ) : (
            <p className="service-provider-screen-no-services">
              No services available
            </p>
          )}
        </div>

        {/* Gallery Section */}
        {usersServices.some((s) => s.Image1 || s.Image2) && (
          <div className="service-provider-screen-section">
            <h2 className="service-provider-screen-section-title">Gallery</h2>
            <div className="service-provider-screen-gallery">
              {usersServices
                .flatMap((service) =>
                  [
                    service.Image1 &&
                      `${url.serviceImageStartingPath}${service.Image1}`,
                    service.Image2 &&
                      `${url.serviceImageStartingPath}${service.Image2}`,
                  ].filter(Boolean)
                )
                .slice(0, 4) // now slicing the flattened array
                .map((image, index) => (
                  <div
                    key={index}
                    className="service-provider-screen-gallery-item"
                    onClick={() => window.open(image, "_blank")}
                  >
                    <img src={image} alt={`Service ${index + 1}`} />
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* Social Media Section */}
        {(serviceDetails.facebook ||
          serviceDetails.instagram ||
          serviceDetails.youtube) && (
          <div className="service-provider-screen-section">
            <h2 className="service-provider-screen-section-title">
              Connect With Us
            </h2>
            <div className="service-provider-screen-social-links">
              {serviceDetails.facebook && (
                <a
                  href={
                    serviceDetails.facebook.startsWith("http")
                      ? serviceDetails.facebook
                      : `https://${serviceDetails.facebook}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="service-provider-screen-social-link facebook"
                >
                  <span className="service-provider-screen-social-icon">
                    📘
                  </span>
                  Facebook
                </a>
              )}
              {serviceDetails.instagram && (
                <a
                  href={
                    serviceDetails.instagram.startsWith("http")
                      ? serviceDetails.instagram
                      : `https://${serviceDetails.instagram}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="service-provider-screen-social-link instagram"
                >
                  <span className="service-provider-screen-social-icon">
                    📷
                  </span>
                  Instagram
                </a>
              )}
              {serviceDetails.youtube && (
                <a
                  href={
                    serviceDetails.youtube.startsWith("http")
                      ? serviceDetails.youtube
                      : `https://${serviceDetails.youtube}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="service-provider-screen-social-link youtube"
                >
                  <span className="service-provider-screen-social-icon">
                    ▶️
                  </span>
                  YouTube
                </a>
              )}
            </div>
          </div>
        )}

        {/* Reviews Section */}
        <div className="service-provider-screen-section">
          <h2 className="service-provider-screen-section-title">
            Customer Reviews
          </h2>

          <div className="service-provider-screen-rating-summary">
            <div className="service-provider-screen-average-rating">
              <div className="service-provider-screen-big-rating">
                {serviceRating.toFixed(1)}
                <span className="service-provider-screen-rating-out-of">
                  /5
                </span>
              </div>
              <div className="service-provider-screen-stars">
                {Array(5)
                  .fill()
                  .map((_, i) => (
                    <span
                      key={i}
                      className={`service-provider-screen-star ${
                        i < Math.round(serviceRating) ? "filled" : ""
                      }`}
                    >
                      {i < Math.round(serviceRating) ? "★" : "☆"}
                    </span>
                  ))}
              </div>
              <div className="service-provider-screen-total-reviews">
                {fullReview.length} reviews
              </div>
            </div>

            <div className="service-provider-screen-rating-bars">
              {[5, 4, 3, 2, 1].map((rating) => (
                <div
                  key={rating}
                  className="service-provider-screen-rating-bar"
                >
                  <span className="service-provider-screen-rating-label">
                    {rating}{" "}
                    <span className="service-provider-screen-star-icon">★</span>
                  </span>
                  <div className="service-provider-screen-progress-container">
                    <div
                      className="service-provider-screen-progress-bar"
                      style={{
                        width: `${
                          fullReview.length > 0
                            ? (ratingCounts[rating] / fullReview.length) * 100
                            : 0
                        }%`,
                      }}
                    ></div>
                  </div>
                  <span className="service-provider-screen-rating-count">
                    {ratingCounts[rating]}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Review Form */}
          {currentUser && (
            <div className="service-provider-screen-review-form">
              <h3 className="service-provider-screen-form-title">
                Write a Review
              </h3>
              <div className="service-provider-screen-emoji-rating">
                {[1, 2, 3, 4, 5].map((rating) => (
                  <span
                    key={rating}
                    className={`service-provider-screen-emoji ${
                      selectedRating === rating ? "selected" : ""
                    }`}
                    onClick={() => setSelectedRating(rating)}
                  >
                    {["😠", "🙁", "😐", "🙂", "😍"][rating - 1]}
                  </span>
                ))}
              </div>
              <textarea
                className="service-provider-screen-review-textarea"
                value={reviewText}
                onChange={(e) => setReviewText(e.target.value)}
                placeholder="Share your experience with this service provider..."
                rows={4}
              />
              <div className="image-section">
                <p className="image-title">Add Photos (Optional)</p>
                <div className="image-grid">
                  {imageFiles.map((file, idx) => (
                    <div key={idx} className="image-box">
                      {file ? (
                        <>
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Review ${idx + 1}`}
                            className="image-preview"
                          />
                          <button
                            className="remove-button"
                            onClick={() => removeImage(idx)}
                          >
                            ✕
                          </button>
                        </>
                      ) : (
                        <label className="add-image-label">
                          +
                          <input
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={(e) =>
                              e.target.files &&
                              pickImage(idx, e.target.files[0])
                            }
                          />
                        </label>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <button
                className="service-provider-screen-submit-review"
                onClick={submitReview}
                disabled={!selectedRating || !reviewText.trim()}
              >
                Submit Review
              </button>
            </div>
          )}

          {/* Reviews List */}
          <div className="service-provider-screen-reviews-list">
            {fullReview.length > 0 ? (
              <>
                {(showAllReviews ? fullReview : fullReview.slice(0, 3)).map(
                  (review, index) => (
                    <div
                      key={index}
                      className="service-provider-screen-review-item"
                    >
                      <div className="service-provider-screen-review-header">
                        <div className="service-provider-screen-reviewer-info">
                          <div className="service-provider-screen-reviewer-avatar">
                            {review.Name
                              ? review.Name.charAt(0).toUpperCase()
                              : "A"}
                          </div>
                          <div>
                            <div className="service-provider-screen-reviewer-name">
                              {review.Name || "Anonymous"}
                            </div>
                            <div className="service-provider-screen-review-date">
                              {new Date(review.Date).toLocaleDateString(
                                "en-US",
                                {
                                  year: "numeric",
                                  month: "long",
                                  day: "numeric",
                                }
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="service-provider-screen-review-rating">
                          {Array(5)
                            .fill()
                            .map((_, i) => (
                              <span
                                key={i}
                                className={`service-provider-screen-review-star ${
                                  i < review.Rating ? "filled" : ""
                                }`}
                              >
                                {i < review.Rating ? "★" : "☆"}
                              </span>
                            ))}
                        </div>
                      </div>

                      <div className="service-provider-screen-review-text">
                        {review.Reviews}

                        {(review.Image1 || review.Image2) && (
                          <div className="service-provider-screen-review-images">
                            {review.Image1 && review.Image1 !== "''" && (
                              <img
                                src={`${url.reviewImageStartingPath}/${review.Image1}`}
                                alt="Review"
                                className="service-provider-screen-review-img"
                                onClick={() =>
                                  window.open(
                                    `${url.reviewImageStartingPath}/${review.Image1}`,
                                    "_blank"
                                  )
                                }
                              />
                            )}
                            {review.Image2 && review.Image2 !== "''" && (
                              <img
                                src={`${url.reviewImageStartingPath}/${review.Image2}`}
                                alt="Review"
                                className="service-provider-screen-review-img"
                                onClick={() =>
                                  window.open(
                                    `${url.reviewImageStartingPath}/${review.Image2}`,
                                    "_blank"
                                  )
                                }
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                )}

                {fullReview.length > 3 && (
                  <button
                    className="service-provider-screen-view-all-reviews"
                    onClick={() => setShowAllReviews(!showAllReviews)}
                  >
                    {showAllReviews
                      ? "Show Less Reviews"
                      : `View All ${fullReview.length} Reviews`}
                  </button>
                )}
              </>
            ) : (
              <div className="service-provider-screen-no-reviews">
                No reviews yet. Be the first to review!
              </div>
            )}
          </div>
        </div>

        {/* Booking Dialog */}
        {bookingDialogOpen && selectedService && (
          <div className="service-provider-screen-booking-dialog">
            <div className="service-provider-screen-booking-content">
              <h2>Book Service</h2>
              <h3>{selectedService.ServiceName}</h3>

              <div className="service-provider-screen-service-options">
                <h4>Select Services:</h4>
                {usersServices.map((service) => (
                  <div
                    key={service.ServiceName}
                    className="service-provider-screen-service-option"
                  >
                    <input
                      type="checkbox"
                      id={service.ServiceName}
                      checked={selectedServices.includes(service.ServiceName)}
                      onChange={(e) =>
                        handleServiceSelection(
                          service.ServiceName,
                          e.target.checked
                        )
                      }
                    />
                    <label htmlFor={service.ServiceName}>
                      {service.ServiceName} - ₹{service.Mrp}
                    </label>
                  </div>
                ))}
              </div>

              <div className="service-provider-screen-booking-total">
                <strong>Total:</strong> ₹{calculateTotalMRP().toFixed(2)}
              </div>

              <div className="service-provider-screen-booking-description">
                <label htmlFor="description">Additional Details:</label>
                <textarea
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Any special requirements or details..."
                />
              </div>

              <div className="service-provider-screen-booking-actions">
                <button
                  className="service-provider-screen-booking-cancel"
                  onClick={() => setBookingDialogOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="service-provider-screen-booking-confirm"
                  onClick={bookService}
                >
                  Confirm Booking
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Snackbar */}
        {snackbar.open && (
          <div
            className={`service-provider-screen-snackbar ${snackbar.severity}`}
          >
            {snackbar.message}
            <button onClick={() => setSnackbar({ ...snackbar, open: false })}>
              ✕
            </button>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

const ServiceCard = ({ service, currentImageIndex, onImageChange, onBookNow }) => {
  const images = [
    service.Image1 && `${url.serviceImageStartingPath}${service.Image1}`,
    service.Image2 && `${url.serviceImageStartingPath}${service.Image2}`,
  ].filter(Boolean);

  return (
    <div className="service-provider-screen-service-card">
      {images.length > 0 && (
        <div className="service-provider-screen-service-image">
          <img
            src={images[currentImageIndex % images.length]}
            alt={service.ServiceName}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/placeholder-image.png";
            }}
          />
          {images.length > 1 && (
            <div className="service-provider-screen-image-indicators">
              {images.map((_, index) => (
                <span
                  key={index}
                  className={`service-provider-screen-indicator ${
                    currentImageIndex % images.length === index ? "active" : ""
                  }`}
                  onClick={() => onImageChange(index)}
                ></span>
              ))}
            </div>
          )}
        </div>
      )}
      <div className="service-provider-screen-service-details">
        <h3 className="service-provider-screen-service-name">
          {service.ServiceName}
        </h3>
        {service.Mrp === "0" || service.Mrp === 0 ? (
          <a
            href={`tel:${service.ProviderMobile}`}
            className="service-provider-screen-call-for-price"
          >
            Call for Price
          </a>
        ) : (
          <p className="service-provider-screen-service-price">
            ₹{service.Mrp}
          </p>
        )}
        <button 
          className="service-provider-screen-service-book-button"
          onClick={onBookNow}
        >
          Book Now
        </button>
      </div>
    </div>
  );
};

export default ServiceProviderDetails;